module.exports = __webpack_public_path__ + "static/exhibitors-264f359b62ff856a20b7fa14ee4ef960.png";